'use client';

import animationData from '@/animations/shared-inbox.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationSharedInboxProps {
  playing?: boolean;
}

const AnimationSharedInbox: FC<AnimationSharedInboxProps> = ({ playing }) => {
  return (
    <div className="flex">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationSharedInbox;
